import { LinkIcon } from "@heroicons/react/24/solid";

export interface IDashboardStatProps {
  title: string | undefined;
  desc: string;
  small?: string;
  color: string;
  onClick?: () => void;
  className?: string;
  // html element
  Icon?: React.ElementType;
}

export default function DashboardStat({
  title,
  desc,
  small,
  color,
  onClick = undefined,
  className = "",
  Icon = LinkIcon,
}: IDashboardStatProps) {
  const textClass = `text-${color}-600`;
  const bgClass = `bg-${color}-100`;

  return (
    <div onClick={onClick} className={`h-full rounded ${bgClass} ${textClass} p-2 px-4 prose-base ${className}
            transition-transform ${onClick ? "cursor-pointer hover:scale-105" : ""}`}>
      {onClick && (<Icon className="h-5 w-5 float-right" />)}
      <h1 className={`${textClass} font-semibold text-2xl`}>
        {title ?? ""}
      </h1>
      <p className="!m-0 text-sm">{desc}</p>
      <p className="!m-0 text-xs">{small}</p>

    </div>
  )
}